import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Grid, Breakpoints, Color, Transition, Type } from '../../app/StyleGuide';
import trainingService from '../../services/trainingService';
import StepLabel from './StepLabel';
import { useSteps, toggleMobileTrainingMenu } from './StepsContext';
import windowService from '../../services/windowService';

const Header = styled.header`
  display: flex;
  width: 100%;
  box-shadow: none;
  align-items: center;
  color: ${Color.white};
  background-color: ${Color.Gray._90};
  @media screen and (min-width: ${Breakpoints.screen_md}) {
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.23);
  }
  h1 {
    order: 1;
    flex-grow: 1;
    min-width: 0;
    font-size: ${Type.Scale._4};
    margin-top: 10px;
    padding: ${Grid._1} ${Grid._3};
    color: ${Color.white};
    span {
      color: ${Color.Gray._30};
      &:after {
        content: ':';
      }
    }
    @media screen and (min-width: ${Breakpoints.screen_md}) {
      padding: ${Grid._3} ${Grid._7};
    }
  }
  a {
    font-size: ${Type.Scale._4};
    text-decoration: none;
    color: ${Color.white};
    padding: ${Grid._4};
    border: none;
    cursor: pointer;
    transition: ${Transition.fast};
    &:after {
      content: '';
    }
  }
  a:nth-of-type(1) {
    order: 0;
    i {
      margin-right: ${Grid._2};
    }
    @media screen and (min-width: ${Breakpoints.screen_md}) {
      font-size: ${Type.Scale._2};
      &:after {
        content: 'Back';
      }
      &:hover {
        text-decoration: underline;
        background: ${Color.Secondary._80};
      }
      padding: ${Grid._5};
      border-right: 1px solid ${Color.Secondary._80};
    }
  }
  a:nth-of-type(2) {
    display: block;
    order: 2;
    i {
      margin-right: ${Grid._2};
    }
    @media screen and (min-width: ${Breakpoints.screen_md}) {
      display: none;
    }
  }
`;

const StepHeader = React.forwardRef((_, ref) => {
  const [{ currentStep, isWorkflow, training }, dispatch] = useSteps();

  const handleBackButton = () => {
    let stepsPrevRoute = localStorage.getItem('routeBeforeSteps');
    let selfAssignPrevRoute = localStorage.getItem('routeBeforeSelfAssign');
    let unAssignOnBack = localStorage.getItem('unAssignOnBack');

    if (stepsPrevRoute) localStorage.removeItem('routeBeforeSteps');
    if (selfAssignPrevRoute) localStorage.removeItem('routeBeforeSelfAssign');
    if (unAssignOnBack) localStorage.removeItem('unAssignOnBack');

    if (stepsPrevRoute) {
      if (unAssignOnBack) {
        trainingService.unassignMyTraining(training.id, isWorkflow ? 'Workflow' : 'TaskList', training.assignedUser);
      }
      windowService.redirectTo(stepsPrevRoute, true);
    } else {
      window.location.replace('#/dashboard/training');
    }
  };

  const taskName = currentStep.taskName || currentStep.task.taskName;
  const taskType = currentStep._type || currentStep.task._type;

  return (
    <Header ref={ref} className="step-header">
      <h1 data-qa-hook="stepName">
        <StepLabel taskType={taskType} /> {taskName}
      </h1>
      <a data-qa-hook="backToMyTraining" onClick={handleBackButton}>
        <i className="fas fa-chevron-left"></i>
      </a>
      <a data-qa-hook="openMobileTrainingSlideMenu" onClick={() => toggleMobileTrainingMenu(dispatch, true)}>
        <i className="fas fa-bars"></i>
      </a>
    </Header>
  );
});

StepHeader.displayName = 'StepHeader';

StepHeader.propTypes = {
  setMarginTop: PropTypes.func,
};

export default StepHeader;
